import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'src/store/redux';

import { UserCustomGroupsResponse } from './types';

export const sharedExpBffApi = createApi({
  reducerPath: 'shared-exp-bff',
  baseQuery: baseQuery('sharedExpBff'),
  endpoints: (builder) => ({
    getUserCustomGroups: builder.query<UserCustomGroupsResponse, void>({
      query: () => {
        const queryParams = 'isSelfMember=true';

        return `edam/groups/my?${queryParams}`;
      },
    }),
  }),
});

// do NOT use it directly - use useUserCustomGroups instead!
export const { useGetUserCustomGroupsQuery } = sharedExpBffApi;
